import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, Button, IconButton  } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Import the close icon
import CreateUserForm from "./CreateUserForm";
import ModifyUserForm from "./ModifyUserForm";

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};

const UserModal = ({ open, onClose, user: passedUser, refreshUsers  }) => {
    const [user, setUser] = useState({}); // Holds the current user details

    // Update the user state whenever the passedUser prop changes
    useEffect(() => {
        if (passedUser) {
            setUser(passedUser);
        } else {
            setUser({});
        }
    }, [passedUser]);

    const handleClose = () => {
        setUser({}); // Reset user state
        onClose(); // Call the parent onClose handler
    };

    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="user-modal-title">
            <Box sx={modalStyle}>
                {/* Modal Header with Close Icon */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography id="user-modal-title" variant="h6" component="h2">
                        {user.id ? "Modify User" : "Add User"}
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Show Create or Modify User Form */}
                {!user.id ? (
                    <CreateUserForm   user={user}
                                      setUser={setUser}
                                      onClose={handleClose}
                                      refreshUsers={refreshUsers} />
                ) : (
                    <ModifyUserForm user={user} setUser={setUser} onClose={handleClose}
                                    refreshUsers={refreshUsers} />
                )}
            </Box>
        </Modal>
    );
};

export default UserModal;
